export const API_PATH_ApiDeviceMgmtLocationChangeId = '/services/device-mgtm/apiDeviceMgmtLocationChangeId';
